import React from 'react';

export default function MGeryonCipher() {
    return (
        <React.Fragment>
            <div className="m-geryon">
                <div className="m-geryon-wrapper">
                    <p>.... --- -.- ..- ...</p>
                    <p>.--. --- -.- ..- ...</p>
                    <p>... .. -- ... .- .-.. .- -... .. --</p>
                </div>
            </div>
        </React.Fragment>
    );
}
